export class Diagnostic {

    //infras_id: string;
    dpe_statut: string;
    dpe_date_begin: string;
    dpe_date_end: string;
    dpe_type: string;
    dpe_vierge: boolean;
    dpe_en_cours: boolean;
    dpe_non_applicable: boolean;
    dpe_value: string;
    dpe_lettre: string;
    dpe_alert: string;
    ges_statut: string;
    ges_date_begin: string;
    ges_date_end: string;
    ges_type: string;
    ges_vierge: string;
    ges_value: string;
    ges_lettre: string;
    ges_alert: string;
    isolation_value: string;
    isolation_lettre: string;

    amiante_statut: string;
    amiante_date_begin: string;
    amiante_date_next: string;
    amiante_date_end: string;
    amiante_alert: string;

    termites_statut: string;
    termites_date_begin: string;
    termites_date_next: string;
    termites_date_end: string;
    termites_alert: string;

    installation_gaz_statut: string;
    installation_gaz_date_begin: string;
    installation_gaz_date_next: string;
    installation_gaz_date_end: string;
    installation_gaz_alert: string;

    installation_electrique_statut: string;
    installation_electrique_date_begin: string;
    installation_electrique_date_next: string;
    installation_electrique_date_end: string;
    installation_electrique_alert: string;

    assainissement_statut: string;
    assainissement_date_begin: string;
    assainissement_date_next: string;
    assainissement_date_end: string;
    assainissement_alert: string;

    plomb_statut: string;
    plomb_date_begin: string;
    plomb_date_next: string;
    plomb_date_end: string;
    plomb_alert: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        //this.infras_id            = data['lots_id'] ? data['lots_id'] : data['batiments_id'] ? data['batiments_id'] : null;
        // this.dpe_statut         = data['dpe_statut'] ? data['dpe_statut'] : null;
        this.dpe_date_begin     = data['dpe_date_begin'] ? data['dpe_date_begin'] : null;
        this.dpe_date_end       = data['dpe_date_end'] ? data['dpe_date_end'] : null;
        this.dpe_type           = data['dpe_type'] ? data['dpe_type'] : null;
        this.dpe_vierge         = data['dpe_vierge'] ? (data['dpe_vierge'] === '1' ? true : false) : false;
        this.dpe_en_cours       = data['dpe_en_cours'] ? (data['dpe_en_cours'] === '1' ? true : false) : false;
        this.dpe_non_applicable = data['dpe_non_applicable'] ? (data['dpe_non_applicable'] === '1' ? true : false) : false;
        this.dpe_value          = data['dpe_value'] ? data['dpe_value'] : null;
        this.dpe_lettre         = data['dpe_lettre'] ? data['dpe_lettre'] : null;
        // this.dpe_alert          = data['dpe_alert'] ? data['dpe_alert'] : null;
        // this.ges_statut         = data['ges_statut'] ? data['ges_statut'] : null;
        this.ges_date_begin     = data['ges_date_begin'] ? data['ges_date_begin'] : null;
        this.ges_date_end       = data['ges_date_end'] ? data['ges_date_end'] : null;
        this.ges_type           = data['ges_type'] ? data['ges_type'] : null;
        // this.ges_vierge         = data['ges_vierge'] ? data['ges_vierge'] : null;
        this.ges_value          = data['ges_value'] ? data['ges_value'] : null;
        this.ges_lettre         = data['ges_lettre'] ? data['ges_lettre'] : null;
        // this.ges_alert          = data['ges_alert'] ? data['ges_alert'] : null;
        this.isolation_value          = data['isolation_value'] ? data['isolation_value'] : null;
        this.isolation_lettre         = data['isolation_lettre'] ? data['isolation_lettre'] : null;

        // this.amiante_statut                     = data['amiante_statut'] ? data['amiante_statut'] : null;
        this.amiante_date_begin                 = data['amiante_date_begin'] ? data['amiante_date_begin'] : null;
        this.amiante_date_next                  = data['amiante_date_next'] ? data['amiante_date_next'] : null;
        this.amiante_date_end                   = data['amiante_date_end'] ? data['amiante_date_end'] : null;
        // this.amiante_alert                      = data['amiante_alert'] ? data['amiante_alert'] : null;

        // this.termites_statut                    = data['termites_statut'] ? data['termites_statut'] : null;
        this.termites_date_begin                = data['termites_date_begin'] ? data['termites_date_begin'] : null;
        this.termites_date_next                 = data['termites_date_next'] ? data['termites_date_next'] : null;
        this.termites_date_end                  = data['termites_date_end'] ? data['termites_date_end'] : null;
        // this.termites_alert                     = data['termites_alert'] ? data['termites_alert'] : null;

        // this.installation_gaz_statut            = data['installation_gaz_statut'] ? data['installation_gaz_statut'] : null;
        this.installation_gaz_date_begin        = data['installation_gaz_date_begin'] ? data['installation_gaz_date_begin'] : null;
        this.installation_gaz_date_next         = data['installation_gaz_date_next'] ? data['installation_gaz_date_next'] : null;
        this.installation_gaz_date_end          = data['installation_gaz_date_end'] ? data['installation_gaz_date_end'] : null;
        // this.installation_gaz_alert             = data['installation_gaz_alert'] ? data['installation_gaz_alert'] : null;

        // this.installation_electrique_statut     = data['installation_electrique_statut'] ? data['installation_electrique_statut'] : null;
        this.installation_electrique_date_begin = data['installation_electrique_date_begin'] ? data['installation_electrique_date_begin'] : null;
        this.installation_electrique_date_next  = data['installation_electrique_date_next'] ? data['installation_electrique_date_next'] : null;
        this.installation_electrique_date_end   = data['installation_electrique_date_end'] ? data['installation_electrique_date_end'] : null;
        // this.installation_electrique_alert      = data['installation_electrique_alert'] ? data['installation_electrique_alert'] : null;

       // this.assainissement_statut              = data['assainissement_statut'] ? data['assainissement_statut'] : null;
        this.assainissement_date_begin          = data['assainissement_date_begin'] ? data['assainissement_date_begin'] : null;
        this.assainissement_date_next           = data['assainissement_date_next'] ? data['assainissement_date_next'] : null;
        this.assainissement_date_end            = data['assainissement_date_end'] ? data['assainissement_date_end'] : null;
        // this.assainissement_alert               = data['assainissement_alert'] ? data['assainissement_alert'] : null;

        // this.plomb_statut                       = data['plomb_statut'] ? data['plomb_statut'] : null;
        this.plomb_date_begin                   = data['plomb_date_begin'] ? data['plomb_date_begin'] : null;
        this.plomb_date_next                    = data['plomb_date_next'] ? data['plomb_date_next'] : null;
        this.plomb_date_end                     = data['plomb_date_end'] ? data['plomb_date_end'] : null;
        // this.plomb_alert                        = data['plomb_alert'] ? data['plomb_alert'] : null;
    }

}
